(() => {
  const media = window.matchMedia('(max-width: 749px)');
  const closeFacets = (event, control) => {
    const drawer = control.closest('menu-drawer');
    const summary = drawer?.querySelector('.mobile-facets__open-wrapper');
    if (!drawer || !summary) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    drawer.closeMenuDrawer(event, summary);
    summary.setAttribute('aria-expanded', 'false');
  };
  // One delegated handler survives the native asynchronous replacement of filter contents.
  document.addEventListener('click', event => {
    const categorySummary = event.target.closest('.pg-subcategory-filter > summary');
    if (categorySummary) { event.stopImmediatePropagation(); return; }
    const continueControl = event.target.closest('[data-pg-continue]');
    if (continueControl) {
      event.preventDefault(); event.stopImmediatePropagation();
      continueControl.closest('cart-drawer')?.close();
      const destination = continueControl.getAttribute('href') || `${window.Shopify?.routes?.root || '/'}#catalog`;
      if (location.pathname === new URL(destination, location.origin).pathname) {
        const menu = document.querySelector('.pg-catalog-menu');
        if (menu) { menu.open = true; menu.querySelector('.pg-catalog-title')?.focus(); document.querySelector('.pg-header')?.scrollIntoView({block:'start'}); }
      } else location.assign(destination);
      return;
    }
    const control = event.target.closest('[data-pg-facets-apply]');
    if (control) closeFacets(event, control);
  }, true);
  document.addEventListener('keydown', event => {
    const category = event.target.closest('.pg-subcategory-filter');
    if (category && event.key === 'Escape' && category.open) {
      event.preventDefault(); event.stopImmediatePropagation(); category.open = false; category.querySelector('summary')?.focus(); return;
    }
    const control = event.target.closest('.mobile-facets__close');
    if (control && ['Enter', ' '].includes(event.key)) closeFacets(event, control);
  }, true);
  const initMenu = () => {
    document.querySelectorAll('.pg-catalog-menu').forEach(menu => {
      if (menu.dataset.pgInitialized) return;
      menu.dataset.pgInitialized = 'true';
      const summary = menu.querySelector(':scope > summary');
      const triggers = [...document.querySelectorAll('[data-pg-menu-open]')];
      const close = () => { menu.open = false; (menu.pgReturnFocus || triggers[0] || summary)?.focus(); };
      triggers.forEach(trigger => trigger.addEventListener('click', event => {
        event.preventDefault(); event.stopPropagation();
        menu.pgReturnFocus = trigger;
        menu.open = !menu.open;
        if (menu.open) menu.querySelector('.pg-catalog-title')?.focus();
      }));
      const groups = [...menu.querySelectorAll('.pg-catalog-group')];
      const setExpanded = (control, expanded) => {
        const panel = document.getElementById(control.getAttribute('aria-controls'));
        if (!panel || !menu.contains(panel)) return;
        control.setAttribute('aria-expanded', String(expanded));
        panel.hidden = !expanded;
        control.closest('.pg-catalog-group, .pg-catalog-subgroup')?.classList.toggle('is-open', expanded);
        control.querySelector('span').textContent = expanded ? '−' : '+';
      };
      const setGroups = () => groups.forEach(group => {
        setExpanded(group.querySelector('[data-pg-catalog-toggle]'), !media.matches);
      });
      menu.querySelectorAll('[data-pg-catalog-toggle]').forEach(control => {
        control.addEventListener('click', () => {
          setExpanded(control, control.getAttribute('aria-expanded') !== 'true');
        });
      });
      setGroups(); media.addEventListener('change', setGroups);
      menu.querySelector('.pg-catalog-close')?.addEventListener('click', close);
      menu.addEventListener('toggle', () => {
        summary?.setAttribute('aria-expanded', String(menu.open));
        triggers.forEach(trigger => trigger.setAttribute('aria-expanded', String(menu.open)));
      });
      menu.addEventListener('focusout', event => {
        // A pointer click can blur a summary without focusing its destination in Safari.
        // Only an explicit focus move outside closes the menu; outside clicks are handled separately.
        if (event.relatedTarget && !menu.contains(event.relatedTarget) && !triggers.includes(event.relatedTarget)) menu.open = false;
      });
      if (location.hash === '#catalog') {
        menu.open = true;
        menu.pgReturnFocus = triggers[0];
        menu.querySelector('.pg-catalog-title')?.focus();
        document.querySelector('.pg-header')?.scrollIntoView({block:'start'});
        // Fragment navigation can move focus again after DOMContentLoaded.
        if (document.readyState !== 'complete') window.addEventListener('load', () => {
          if (menu.open) menu.querySelector('.pg-catalog-title')?.focus();
        }, {once:true});
      }
    });
  };
  const initSearch = () => document.querySelectorAll('.pg-search').forEach(search => {
    if (search.dataset.pgSubmitInitialized) return;
    search.dataset.pgSubmitInitialized = 'true';
    const button = search.querySelector('.pg-search-submit');
    button?.addEventListener('click', event => {
      // Explicit button clicks submit all results; Enter in the input still follows its selected suggestion.
      if (event.detail > 0 || document.activeElement === button) {
        search.querySelectorAll('[aria-selected="true"]').forEach(item => item.setAttribute('aria-selected', 'false'));
        search.querySelector('input[type="search"]')?.removeAttribute('aria-activedescendant');
      }
    });
  });
  const initReviews = () => {
    if (!/^ro(?:-|$)/i.test(document.documentElement.lang)) return;
    const root = document.getElementById('trustshop-review');
    if (!root || root.dataset.pgReviewLabels) return;
    root.dataset.pgReviewLabels = 'true';
    // Localize controls only. Public reviews, rating values and app events stay intact.
    const copy = new Map([
      ['All ratings', 'Toate evaluările'], ['Sort by', 'Sortează după'],
      ['1 star', '1 stea'], ['2 stars', '2 stele'], ['3 stars', '3 stele'],
      ['4 stars', '4 stele'], ['5 stars', '5 stele']
    ]);
    const localize = () => {
      root.querySelectorAll('button, .trustshop-review-sort--wrap, .trustshop-minimal-filter--selected, [role="option"]').forEach(control => {
        const walker = document.createTreeWalker(control, NodeFilter.SHOW_TEXT);
        while (walker.nextNode()) {
          const node = walker.currentNode;
          const translated = copy.get(node.nodeValue.trim());
          if (translated) node.nodeValue = node.nodeValue.replace(node.nodeValue.trim(), translated);
        }
      });
      root.querySelectorAll('[aria-label="Filter by all"], [aria-label="Filter by review with photos"]').forEach(control => {
        control.setAttribute('aria-label', control.getAttribute('aria-label') === 'Filter by all' ? 'Toate recenziile' : 'Recenzii cu fotografii');
      });
      // TrustShop mounts its filter popovers outside the review root.
      document.querySelectorAll('.trustshop-checkbox input[aria-label]').forEach(control => {
        const label = control.getAttribute('aria-label');
        const translated = copy.get(label);
        const starFilter = label.match(/^([1-5]) star filter$/);
        if (translated) control.setAttribute('aria-label', translated);
        else if (starFilter) control.setAttribute('aria-label', `Filtru ${starFilter[1]} ${starFilter[1] === '1' ? 'stea' : 'stele'}`);
      });
    };
    let scheduled = false;
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; localize(); });
    }).observe(root, { childList: true, subtree: true, characterData: true });
    localize();
  };
  const initSizeGuides = () => {
    document.querySelectorAll('.product__description img').forEach(image => {
      if (image.dataset.pgSizeGuide) return;
      const source = image.currentSrc || image.src;
      if (!/ghid|tabel|marim|dimensionar|size.?chart/i.test(source + ' ' + image.alt)) return;
      let url;
      try { url = new URL(source, location.href); } catch (_) { return; }
      if (!['https:', 'http:'].includes(url.protocol)) return;
      image.dataset.pgSizeGuide = 'true';
      const title = image.closest('product-info')?.querySelector('h1')?.textContent.trim() || '';
      if (!image.alt.trim()) image.alt = `Tabel de mărimi${title ? ` — ${title}` : ''}`;
      const link = document.createElement('a');
      link.className = 'pg-size-guide-zoom';
      link.href = url.href;
      link.target = '_blank';
      link.rel = 'noopener';
      link.textContent = 'Mărește tabelul de mărimi ↗';
      link.setAttribute('aria-label', `Deschide tabelul de mărimi${title ? ` pentru ${title}` : ''} într-o filă nouă`);
      (image.closest('a') || image).insertAdjacentElement('afterend', link);
    });
  };
  const init = () => { initMenu(); initSearch(); initReviews(); initSizeGuides(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('product-info:loaded', initSizeGuides);
})();
